export default "/images/vendor/flag-icons/flags/1x1/mp.svg?71d393f4452bdea22af3ea3cf9906f88";